/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Metric_MinutesInputs */



/**
* | output |
* | --- |
* | "Minutes" |
*
* @param {Usage_Metric_MinutesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_metric_minutes = /** @type {((inputs?: Usage_Metric_MinutesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Metric_MinutesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Minutes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Minuten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Minuti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Протокол")
	if (locale === "es") return /** @type {LocalizedString} */ ("Minutos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分钟")
	if (locale === "ja") return /** @type {LocalizedString} */ ("分")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मिनट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Minutos")
	return /** @type {LocalizedString} */ ("Minutes")
});